import { render, staticRenderFns } from "./project-pictograms.vue?vue&type=template&id=13d4c40c"
import script from "./project-pictograms.vue?vue&type=script&lang=js"
export * from "./project-pictograms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports